// QR / shared-link entry pages. Each is its own chunk, so a scan only
// downloads the page it lands on (previously all five were eager and every
// visitor paid for all of them in the main bundle).
//
// main.tsx calls preloadRouteChunkForPath() before React renders, so the
// matching chunk downloads in parallel with the page's data prefetch instead
// of waiting for React to reach the lazy boundary. import() is cached by the
// module system, so React.lazy reuses the same in-flight promise.
//
// Keep this file free of app imports other than constants (no store, no slices): it is imported
// by main.tsx and App.tsx, and must not add edges to the UiDb import cycle.

import {
  BUSINESS_PAGE_PATH_RE,
  PRODUCT_DETAILS_PATH_RE,
  DINE_IN_PATH_RE,
  BUSINESS_COLLECTION_PATH_RE,
  LISTING_COLLECTION_PATH_RE,
} from "../constants/RoutePatterns";

export const loadProductDetailsV2 = () =>
  import("../components/features/Product/ProductDetailsV2/ProductDetailsV2");
export const loadBusinessListings = () =>
  import("../components/pages/businessListings/BusinessListings");
export const loadDineIn = () => import("../components/pages/dineIn/DineIn");
export const loadBusinessCollectionPage = () =>
  import("../components/pages/businessCollection/BusinessCollectionPage");
export const loadListingCollectionPage = () =>
  import("../components/pages/listingCollection/ListingCollectionPage");

const ROUTE_CHUNKS: Array<[RegExp, () => Promise<unknown>]> = [
  [PRODUCT_DETAILS_PATH_RE, loadProductDetailsV2],
  [BUSINESS_PAGE_PATH_RE, loadBusinessListings],
  [DINE_IN_PATH_RE, loadDineIn],
  [BUSINESS_COLLECTION_PATH_RE, loadBusinessCollectionPage],
  [LISTING_COLLECTION_PATH_RE, loadListingCollectionPage],
];

export function preloadRouteChunkForPath(pathname: string): void {
  for (const [re, load] of ROUTE_CHUNKS) {
    if (re.test(pathname)) {
      // A failed preload is retried by React.lazy on render; swallow here.
      load().catch(() => undefined);
      return;
    }
  }
}
